import React from 'react';
import { NextSeo } from 'next-seo';
import MainLayout from '@views/layouts/main-layout';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';
import Quotation from '@views/modules/quotation';
import { HOST } from '@lib/helpers';

export const QuotationPage = (): JSX.Element => {
  const breadcrumb = (
    <BreadcrumbComponent
      options={[
        {
          name: 'Báo giá',
          active: true,
        },
      ]}
    />
  );

  return (
    <MainLayout breadcrumb={breadcrumb}>
      <NextSeo title="Báo giá" canonical={`${HOST}/bao-gia`} />
      <Quotation />
    </MainLayout>
  );
};

export default QuotationPage;
